import React from "react";
import "./sources.css";

const Sources = ({ title }) => {
  title = "Revenue Sources";
  return (
    <div className="pvxSources">
      <div className="head">
        <div className="text">{title}</div>
        <img
          src="./images/PvxDashboard/Icons/Dots.svg"
          className="dots"
          alt="Dots"
        />
      </div>
      <div className="body">
        <div className="orange">
          <img src="./images/PvxDashboard/StatCard/Orange.svg" alt="Orange" />
          <div className="data">
            <div className="value">$200</div>
            <div className="text">Others</div>
          </div>
        </div>
        <div className="darkBlue">
          <img src="./images/PvxDashboard/StatCard/DarkBlue.svg" alt="darkBlue" />
          <div className="data">
            <div className="value">$2000</div>
            <div className="text">Subscriptions</div>
          </div>
        </div>
        <div className="lightBlue">
          <img src="./images/PvxDashboard/StatCard/LightBlue.svg" alt="lightBlue" />
          <div className="data">
            <div className="value">$300</div>
            <div className="text">Monetization</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sources;
